import { $f } from '@/core/services/formatter';

export default {
    install: (app) => {
        app.config.globalProperties.$currency = (symbol, value, decimals) => {
            return $f.currency(symbol, value, decimals);
        };
    },
};
